import React from 'react';

const steps = [
  {
    title: "Select Your Plan",
    description: "Choose the subscription plan that best suits your business needs.",
  },
  {
    title: "Get Matched with a Legal Expert",
    description: "We assign an experienced legal professional to your account.",
  },
  {
    title: "Receive Ongoing Support",
    description: "Access your dedicated legal expert anytime for comprehensive legal services.",
  }
];

const Stepper = () => {
  return (
    <div className="max-w-4xl mx-auto py-12">
      {/* <h2 className="text-center text-3xl font-semibold text-gray-800 mb-8">How It Works</h2> */}
      <div className="flex flex-col space-y-6">
        {steps.map((step, index) => (
          <div key={index} className="relative flex items-center">
            {/* Step Number */}
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-emerald-500 rounded-full text-white font-bold">
              {index + 1}
            </div>
            {/* Step Content */}
            <div className="ml-4">
              <h3 className="text-lg font-bold text-gray-700">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
            {/* Arrow */}
            {/* {index < steps.length - 1 && (
              <FontAwesomeIcon icon={faArrowRight} className="absolute right-0 text-gray-400 w-5 h-5 transform translate-x-6" />
            )} */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Stepper;
